import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { useAppearance } from "../lib/context/AppearanceContext";

const AppearanceToggle = () => {
  const { appearance, setAppearance } = useAppearance();

  const handleChange = (color) => {
    setAppearance(color);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex w-full gap-2 items-center">
          <Button variant="outline" size="icon">
            <div className="h-6 w-6 border bg-webPrimary rounded-sm" />
          </Button>
          <div className="grid flex-1 text-left text-sm leading-tight">
            Color Change
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {["blue", "indigoBlue", "trustBlue", "purple", "grey", "softBlue"].map((color) => (
          <DropdownMenuItem
            key={color}
            onClick={() => handleChange(color)}
            className={appearance === color ? "bg-webSecondary text-white" : ""}
          >
            <div
              className={`h-6 w-6 border rounded-sm mr-2 ${
                color === "softBlue"
                  ? "bg-[#4BA3C7]"
                  : color === "grey"
                  ? "bg-[#254D70]"
                  : color === "purple"
                  ? "bg-[#8f59a6]"
                  : color === "trustBlue"
                  ? "bg-[#084B83]"
                  : color === "indigoBlue"
                  ? "bg-[#191970]"
                  : "bg-[#0078C8]"
              }`}
            />
            {color === "softBlue" ? "Soft Blue" : color === "trustBlue" ? "Trust Blue" : color === "indigoBlue" ? "Indigo" : color.charAt(0).toUpperCase() + color.slice(1)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AppearanceToggle;
